document.addEventListener('DOMContentLoaded', function () {

  /* ---------- mobile nav ---------- */
  var burger = document.getElementById('halayBurger');
  var mobileNav = document.getElementById('halayMobileNav');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      mobileNav.classList.toggle('show');
    });
  }

  /* ---------- mobile nav dropdowns ---------- */
  var mobileDropdownToggles = document.querySelectorAll('.mobile-nav-link-toggle');
  mobileDropdownToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var item = toggle.closest('.mobile-nav-item');
      var isOpen = item.classList.contains('open');
      item.classList.toggle('open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---------- search flyout ---------- */
  var searchToggle = document.getElementById('halaySearchToggle');
  var searchFlyout = document.getElementById('halaySearchFlyout');
  if (searchToggle && searchFlyout) {
    searchToggle.addEventListener('click', function () {
      searchFlyout.classList.toggle('show');
      var input = searchFlyout.querySelector('input');
      if (searchFlyout.classList.contains('show') && input) input.focus();
    });
  }

  /* ---------- mini cart toast ---------- */
  var miniCart = document.getElementById('halayMiniCart');
  var miniCartTimer;
  function showMiniCart() {
    if (!miniCart) return;
    miniCart.classList.add('show');
    clearTimeout(miniCartTimer);
    miniCartTimer = setTimeout(function () { miniCart.classList.remove('show'); }, 2200);
  }

  /* ---------- update cart count bubble ---------- */
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('halayCartCount');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  /* ---------- AJAX add to cart for every relevant form ---------- */
  function bindAddToCartForms() {
    document.querySelectorAll('form[action^="/cart/add"], #halayProductForm').forEach(function (form) {
      if (form.dataset.halayBound) return;
      form.dataset.halayBound = 'true';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          refreshCartCount();
          showMiniCart();
        })
        .catch(function (err) {
          alert(err && err.description ? err.description : 'Dit product kon niet worden toegevoegd.');
        });
      });
    });
  }
  bindAddToCartForms();

  /* ---------- product page: gallery thumbnails ---------- */
  var mainImage = document.getElementById('halayMainImage');
  var productThumbs = document.querySelectorAll('.product-thumb');
  productThumbs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (mainImage) mainImage.src = btn.dataset.full;
      productThumbs.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  function setActiveThumbById(imageId) {
    if (!imageId) return;
    productThumbs.forEach(function (b) {
      b.classList.toggle('active', String(b.dataset.imageId) === String(imageId));
    });
  }

  function updateVariantImage(match) {
    if (!match || !match.featured_image) return;
    var img = match.featured_image;
    if (mainImage) {
      mainImage.src = img.src;
      mainImage.alt = img.alt || mainImage.alt;
    }
    setActiveThumbById(img.id);
  }

  /* ---------- product page: variant selection ---------- */
  var variantSelects = document.querySelectorAll('.halay-variant-select');
  if (variantSelects.length && window.__halayProductVariants) {
    var variants = window.__halayProductVariants;
    var variantIdInput = document.getElementById('halayVariantId');
    var priceEl = document.getElementById('halayProductPrice');
    var addBtn = document.getElementById('halayAddToCartBtn');
    var stockEl = document.getElementById('halayStockUrgency');
    var eanEl = document.getElementById('halayProductEan');
    var stickyPriceEl = document.querySelector('.sticky-buybar-price');
    var stickyAddBtn = document.getElementById('halayStickyAddBtn');

    function currentSelection() {
      return Array.from(variantSelects).map(function (s) { return s.value; });
    }
    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }
    function formatMoney(cents) {
      return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
    variantSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        var match = findVariant(currentSelection());
        if (!match) return;
        if (variantIdInput) variantIdInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(match.price);
        updateVariantImage(match);
        if (eanEl) {
          if (match.barcode) {
            eanEl.textContent = 'EAN: ' + match.barcode;
            eanEl.style.display = '';
          } else {
            eanEl.style.display = 'none';
          }
        }
        if (stockEl) {
          stockEl.classList.remove('ok', 'out');
          if (!match.available) {
            stockEl.textContent = 'Tijdelijk uitverkocht';
            stockEl.classList.add('out');
          } else if (match.inventory_management === 'shopify' && match.inventory_quantity <= 5 && match.inventory_quantity > 0) {
            stockEl.textContent = 'Nog maar ' + match.inventory_quantity + ' op voorraad';
          } else {
            stockEl.textContent = 'Op voorraad - voor 16:00 besteld, morgen verzonden';
            stockEl.classList.add('ok');
          }
        }
        [addBtn, stickyAddBtn].forEach(function (btn) {
          if (!btn) return;
          if (match.available) {
            btn.disabled = false;
            btn.style.opacity = '';
            btn.textContent = 'In winkelwagen';
          } else {
            btn.disabled = true;
            btn.style.opacity = '0.5';
            btn.textContent = 'Uitverkocht';
          }
        });
      });
    });
  }

  /* ---------- bestsellers slider ---------- */
  (function () {
    var row = document.getElementById('halayProductRow');
    var prev = document.getElementById('halaySliderPrev');
    var next = document.getElementById('halaySliderNext');
    var dotsWrap = document.getElementById('halaySliderDots');
    if (!row) return;

    function cardStep() {
      var card = row.querySelector('.p-card');
      if (!card) return 300;
      var style = getComputedStyle(row);
      var gap = parseFloat(style.columnGap || style.gap || 24);
      return card.getBoundingClientRect().width + gap;
    }
    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: cardStep(), behavior: 'smooth' }); });

    if (dotsWrap) {
      var cards = row.querySelectorAll('.p-card');
      cards.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.classList.add('active');
        d.addEventListener('click', function () { row.scrollTo({ left: i * cardStep(), behavior: 'smooth' }); });
        dotsWrap.appendChild(d);
      });
      var dots = dotsWrap.querySelectorAll('span');
      var ticking = false;
      row.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var idx = Math.round(row.scrollLeft / cardStep());
          dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
          ticking = false;
        });
      });
    }
  })();

  /* ---------- quantity stepper ---------- */
  var qtyInput = document.getElementById('halayQtyInput');
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var step = parseInt(btn.dataset.step, 10);
      var current = parseInt(qtyInput.value, 10) || 1;
      var next = current + step;
      if (next < 1) next = 1;
      qtyInput.value = next;
    });
  });

  /* ---------- sticky add-to-cart bar on product pages ---------- */
  var stickyBar = document.getElementById('halayStickyBuybar');
  var buyBox = document.querySelector('.buy-box');
  if (stickyBar && buyBox) {
    var stickyAdd = document.getElementById('halayStickyAddBtn');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        var mainBtn = document.getElementById('halayAddToCartBtn');
        if (mainBtn && !mainBtn.disabled) mainBtn.click();
      });
    }
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      observer.observe(buyBox);
    }
  }

  /* ---------- filter chips (visual only demo) ---------- */
  document.querySelectorAll('.chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      document.querySelectorAll('.chip').forEach(function (c) { c.classList.remove('active'); });
      chip.classList.add('active');
    });
  });

});
